import React, { useState } from 'react'
import './accordion.scss'

type TAccordion = {
	title: string;
	links: Array<{ title: string, redirectURL: string }>
}

const Accordion = (props: TAccordion) => {
	const { title, links } = props;
	const [open, setOpen] = useState(false);

	return (
		<>
			<div className="t-accordion" onClick={() => setOpen(!open)} >
				<p data-icon={open ? '-' : '+'}>{title}</p>
			</div>
			<span className="t-accordion__divider"></span>
			{
				open &&
				<div className="t-accordion__link-container">
					{
						links.map(link => (
							<a
								key={link.redirectURL}
								className="t-accordion__link-container__link"
								href={link.redirectURL}
								rel="noreferer"
								target='__blank'
							>
								{link.title}
							</a>
						))
					}
				</div>
			}
		</>
	)
}

export default Accordion